import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { AppContextProvider } from './context/AppContext';
import React, { useContext, Suspense } from 'react';
import Home from "./pages/Auth/Home";
import SignIn from "./pages/Auth/SignIn";
import PrivateRoute from './components/PrivateRoute'
import ScrollToTop from './components/ScrollToTop';
import Loader from './components/Loader';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Error from './pages/Error';

import User from './pages/User/Index';
import UserView from './pages/User/View';

import SpIndex from './pages/User/Sp/Index';
import SpIndexView from './pages/User/Sp/View';

import Cluster from './pages/Cluster/Index';

import Tag from './pages/Tag/Index';

import Cms from './pages/Cms/Index';
import CmsAddEdit from './pages/Cms/AddEdit';

import Category from './pages/Category/Index';

import Brand from './pages/Brand/Index';
import BrandAdd from './pages/Brand/Add';
import BrandEdit from './pages/Brand/Edit';
import BrandView from './pages/Brand/View';
import BrandSuggestion from './pages/Brand/Suggestion';

import City from './pages/City/Index';
import PublicPage from './pages/PublicPage/Index';

window.Buffer = window.Buffer || require("buffer").Buffer;

function App() {

  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {

  const { isLoggedIn } = useContext(AuthContext)

  return (
    <Routes >
      <Route path="/login" element={<SignIn />} />
      <Route exact path="/cms/:slug" element={<PublicPage />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>}
      >

        {/* Auth Routes */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/dashboard" element={<Home />} />

        {/* User Routes */}
        <Route exact path="/user" element={<User />} />
        <Route exact path="/user/view/:id" element={<UserView />} />
        {/* Service / Product User Routes */}
        <Route exact path="/user/service-product/:user_id" element={<SpIndex />} />
        <Route exact path="/user/service-product/view/:user_id/:id" element={<SpIndexView />} />

        {/* Category Routes */}
        <Route exact path="/category" element={<Category />} />

        {/* Brand Routes */}
        <Route exact path="/brand" element={<Brand />} />
        <Route exact path="/brand/Add" element={<BrandAdd />} />
        <Route exact path="/brand/update/:id" element={<BrandEdit />} />
        <Route exact path="/brand/view/:id" element={<BrandView />} />
        <Route exact path="/brand/suggestion" element={<BrandSuggestion/>} />

        {/* City Routes */}
        <Route exact path="/city" element={<City />} />

        {/* Cluster Routes */}
        <Route exact path="/cluster" element={<Cluster />} />

        {/* Tag Routes */}
        <Route exact path="/tag" element={<Tag />} />

        {/* CMS Routes */}
        <Route exact path="/cms" element={<Cms />} />
        <Route exact path="/cms/add-edit/:id?" element={<CmsAddEdit />} />

      </Route >

      <Route path="*" element={<Error />} />
    </Routes >
  )
}

const Layout = () => {
  return (<> <Outlet />  </>
  )
}

export default App;